
<div class="search-user-modal">
  <div class="modal-header">
    <span>Search User</span>
    <button class="search-user-close"(click)="activeModal.dismiss('Cross click')" aria-label="Close">&times;</button>
  </div>
  <div class="search-user-modal-body">
    <div class="" title="">
      <div style="margin-bottom: 5px">
        <input [(ngModel)]="data.searchText" (keydown)="keyDown($event)" placeholder="name" class="search-user-input" />
        <i class="fa fa-search search-user-search-icon" (click)="startSearch()"></i>
      </div>
      <div class="search-user-total">
        Total: {{data.totalUserCount}}
        @if (data.totalUserCount > 0) {
          <span>(page {{data.page}} of {{data.lastPage}})</span>
        }
        <span style="float:right; margin-right: 5px">
          @if (data.page > 1) {
            <i class="fa fa-chevron-left" style="cursor: pointer;" (click)="jumpPage(-1)" title="previous"></i>
          }
          &nbsp;&nbsp;&nbsp;&nbsp;
          @if (data.page < data.lastPage) {
            <i class="fa fa-chevron-right" style="cursor: pointer;" (click)="jumpPage(1)" title="next"></i>
          }
        </span>
      </div>

      <div class="search-user-divider"></div>
      <div class="search-user-list">
        @for (user of data.users; track user) {
          <div class="search-user-row">
            <span class="search-user-name">{{user.name}}</span>
            <!-- <img *ngIf="user.visible" src="assets/img/eyeVisible.svg" class="search-user-eye" (click)="toggleUserVisibility(user)" />
            <img *ngIf="!user.visible" src="assets/img/eyeHidden.svg" class="search-user-eye" (click)="toggleUserVisibility(user)" />
            <i *ngIf="user.visible" class="fa fa-info-circle" (click)="showUserInfo(user)" style="margin-left: 5px; padding-top: 5px"></i></div> -->
          </div>
        }
      </div>
    </div>
  </div>
